import React, { PureComponent } from 'react';
import { ReactComponent as BrowseArrowRightIcon } from '../../assets/icons/homepage-link-arrow.svg';
import { HomePageLinksSectionItems } from './homepage.consts';
import { track, TrackedEvent } from '../../core/analytics';
import './homepage-links.scss';
import { sleepByMs } from '../../core/utils';

const HomePageInitDurationMs: number = 1200;

interface Props {}

interface State {
  isInit: boolean;
  confirmedIndexes: { [index: number]: boolean };
}

class HomepageLinks extends PureComponent<Props, State> {
  isExisting: boolean;
  intersectionObserver: IntersectionObserver;
  anchorElsMapByIndex: { [index: number]: HTMLDivElement } = {};

  constructor(props) {
    super(props);
    this.state = {
      isInit: false,
      confirmedIndexes: {},
    };
    this.intersectionObserver = new IntersectionObserver((entries: IntersectionObserverEntry[]) => {
      (entries || []).forEach((entry) => {
        const anchorEl = entry.target as HTMLAnchorElement;
        const anchorElIndex = anchorEl.dataset['index'];
        if (anchorEl) {
          if (!this.isExisting) {
            return;
          }
          this.setState((curState) => {
            return {
              confirmedIndexes: {
                ...curState.confirmedIndexes,
                [anchorElIndex]: !curState.confirmedIndexes[anchorElIndex]
                  ? entry.intersectionRatio !== 0
                    ? true
                    : false
                  : true,
              },
            };
          });
        }
      });
    });
  }

  storeAnchorElRef = (el: HTMLAnchorElement) => {
    if (!el) {
      return;
    }
    this.anchorElsMapByIndex[el.dataset.index] = el;

    if (this.anchorElsMapByIndex[el.dataset.index] && this.intersectionObserver) {
      this.intersectionObserver.observe(this.anchorElsMapByIndex[el.dataset.index]);
    }
  };

  async componentDidMount() {
    this.isExisting = true;
    await sleepByMs(HomePageInitDurationMs);
    if (!this.isExisting) {
      return;
    }
    this.setState({
      isInit: true,
    });
  }

  componentWillUnmount(): void {
    this.isExisting = false;
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }

    Object.values(this.anchorElsMapByIndex).forEach((anchorEl) => {
      if (anchorEl && this.intersectionObserver) {
        this.intersectionObserver.unobserve(anchorEl);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        {HomePageLinksSectionItems.map((item, index) => {
          const isConfirmed: boolean = this.state.isInit && this.state.confirmedIndexes[index];
          return (
            <a
              key={index}
              className={`homepage-links-item ${isConfirmed ? 'is-visible' : ''}`}
              target="_blank"
              href={item.href}
              onClick={() => {
                track(TrackedEvent.homePageLinksItemClicked, { href: item.href });
              }}
              data-index={index}
              ref={this.storeAnchorElRef}
            >
              <div
                className="homepage-links-item-left-section"
                style={{ backgroundImage: `url(${item.imageUrl})` }}
              ></div>
              <div className="homepage-links-item-right-section">
                <div dangerouslySetInnerHTML={{ __html: item.label }}></div>
                <div>
                  <span>{item.cta}</span>
                  <BrowseArrowRightIcon />
                </div>
              </div>
            </a>
          );
        })}
      </React.Fragment>
    );
  }
}

export default HomepageLinks;
